{
  "name": "smartregion-proficontrol-ui",
  "version": "4.6.2",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "type-check": "vue-tsc --noEmit",
    "build": "vite build --outDir proficontrol-ui",
    "preview": "vite preview",
    "test": "vitest",
    "test:ui": "vitest --ui"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "dependencies": {
    "@mdi/font": "^7.4.47",
    "fast-deep-equal": "^3.1.3",
    "ibantools": "^4.5.4",
    "jwt-decode": "^4.0.0",
    "maska": "^3.0.2",
    "moment": "^2.29.1",
    "qrcode.vue": "^3.8.0",
    "vite-plugin-vuetify": "^2.0.4",
    "vue": "^3.5.12",
    "vue-i18n": "^11.4.0",
    "vue-router": "^5.0.6",
    "vuetify": "^3.7.13"
  },
  "devDependencies": {
    "@intlify/unplugin-vue-i18n": "^6.0.8",
    "@types/node": "^25.5.0",
    "@vitejs/plugin-vue": "^6.0.6",
    "@vue/compiler-sfc": "^3.5.12",
    "@vue/test-utils": "^2.4.6",
    "jsdom": "^29.0.1",
    "sass": "^1.32.0",
    "terser": "^5.30.0",
    "typescript": "~5.9.0",
    "vite": "^8.0.0",
    "vitest": "^4.1.1",
    "vue-tsc": "^3.2.8"
  },
  "browserslist": [
    "> 1%",
    "last 2 versions",
    "not dead"
  ]
}
